import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import {
  Settings,
  MonetizationOn,
  Assignment,
  Category,
  PersonAdd,
  Diversity3,
  Grade,
} from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
// configuration files
import { Shifts } from "./Configuration/Shifts";
import { ShiftGrade } from "./Configuration/ShiftGrade";
import { ShiftRota } from "./Configuration/ShiftAssignment";
import { ShiftCategory } from "./Configuration/ShiftCategory";
import { ShiftRotaProvider } from "./Configuration/ShiftAssignment/ShiftRotaContext";
//assignment files
import { AssignShiftGrade } from "./Assignment/ShiftGrade";
import { AssignShiftGroup } from "./Assignment/ShiftGroup";
import { AssignShiftCategory } from "./Assignment/ShiftCategory";
import { themes } from "services/constants";
//customFilter
import { FilterProvider } from "../../FilterContext";
import { setFilterApi } from "services/Redux/userManagament";
import { sideBarWidth, theme } from "services/constants";

export const HRShift = () => {
  const [selectedShiftItem, setSelectedShiftItem] = useState("Shift");
  const shiftSidebarOpen = true;
  const [showFullPage, setShowFullPage] = useState(false);
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer
  );

  const shiftModule = userScreenAccess?.module_details.find(
    (mod) => mod.module_name === "Shift"
  );
  const dispatch = useDispatch();

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === selectedShiftItem
  )?.sub_module_id;

  const shiftMenuItems = [
    {
      type: "title",
      title: "Configuration",
    },

    {
      type: "item",
      title: "Shift",
      key: "Shift",
      subtitle: "Configure the shift time & Break",
      icon: <Settings />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Shift Grade",
      key: "Shift Grade",
      subtitle: "Configure week-off",
      icon: <MonetizationOn />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Shift Roster",
      key: "Shift Roster",
      subtitle: "Schedule shift rotation",
      icon: <Assignment />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Shift Category",
      key: "Shift Category",
      subtitle: "Configure employee pay",
      icon: <Category />,
      color: "#6c757d",
    },
    {
      type: "title",
      title: "Assignment",
    },
    {
      type: "item",
      title: "Shift Grade",
      key: "Employee Shift Grade",
      groupKey: "Group Shift Grade",
      subtitle: "Map employees to grade",
      icon: <Grade />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Shift Group",
      key: "Employee Shift Group",
      subtitle: "Map employees to group",
      icon: <Diversity3 />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Shift Category",
      key: "Employee Shift Category",
      subtitle: "Map employees to category",
      icon: <PersonAdd />,
      color: "#6c757d",
    },
  ];

  const handleShiftItemClick = (itemTitle) => {
    if (selectedShiftItem === itemTitle) return;
    setSelectedShiftItem(itemTitle);
    dispatch(setFilterApi(true));
    setShowFullPage(false);
  };

  const renderMainContent = () => {
    switch (selectedShiftItem) {
      case "Shift":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <Shifts
              showFullPage={showFullPage}
              setShowFullPage={setShowFullPage}
            />
          </FilterProvider>
        );
      case "Shift Grade":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <ShiftGrade setSelectedShiftItem={setSelectedShiftItem} />
          </FilterProvider>
        );
      case "Shift Roster":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <ShiftRotaProvider>
              <ShiftRota
                showFullPage={showFullPage}
                setShowFullPage={setShowFullPage}
              />
            </ShiftRotaProvider>
          </FilterProvider>
        );
      case "Shift Category":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <ShiftCategory setSelectedShiftItem={setSelectedShiftItem} />
          </FilterProvider>
        );
      case "Group Shift Grade":
      case "Employee Shift Grade":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <AssignShiftGrade setSelectedShiftItem={setSelectedShiftItem} />
          </FilterProvider>
        );
      case "Group Shift Group":
      case "Employee Shift Group":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <AssignShiftGroup setSelectedShiftItem={setSelectedShiftItem} />
          </FilterProvider>
        );
      case "Group Shift Category":
      case "Employee Shift Category":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <AssignShiftCategory setSelectedShiftItem={setSelectedShiftItem} />
          </FilterProvider>
        );
      default:
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <Shifts />;
          </FilterProvider>
        );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height: "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: shiftSidebarOpen ? sideBarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {shiftMenuItems.map((item, index) =>
              item.type === "title" ? (
                <Typography
                  key={`title-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handleShiftItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        selectedShiftItem === (item.key ?? item.groupKey)
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          selectedShiftItem === item.key
                            ? "#00D4AA"
                            : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor: "#f5f5fd",
            transition: "all 0.3s ease",
          }}
        >
          {shiftSidebarOpen && !showFullPage && (
            <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
              <Typography>HR Zone</Typography>
              <Typography>Shift</Typography>
              <Typography color={themes?.blueColor}>
                {selectedShiftItem}
              </Typography>
            </Breadcrumbs>
          )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
